import styles from './Event.module.scss';
import CardEvent from './CardEvent';
import VideoEvent from './VideoEvent';
import { StartDot, Spacer } from '../Primitives/Primitives';
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const eventDecider = (
  event,
  setPulse,
  date,
  id,
  isAnimated,
  containerDimension,
  isFirstItem,
  headingLevel,
) =>
  event?.isVideo ? (
    <VideoEvent
      containerDimension={containerDimension}
      date={date}
      event={event}
      id={id}
      setPulse={setPulse}
    />
  ) : (
    <CardEvent
      containerDimension={containerDimension}
      date={date}
      event={event}
      headingLevel={headingLevel}
      id={id}
      isAnimated={isAnimated}
      isFirstItem={isFirstItem}
      setPulse={setPulse}
    />
  );

export const SingleEvent = ({
  id,
  spacer,
  events: [singleEvent],
  date,
  isAnimated = false,
  containerDimension,
  isFirstItem = false,
  headingLevel,
}) => {
  const [pulse, setPulse] = useState(false);

  return (
    <>
      <StartDot pulse={pulse} />
      {eventDecider(
        singleEvent,
        setPulse,
        date,
        id,
        isAnimated,
        containerDimension,
        isFirstItem,
        headingLevel,
      )}
      <Spacer id={id} spacer={spacer} />
    </>
  );
};

SingleEvent.propTypes = {
  containerDimension: PropTypes.string,
  date: PropTypes.string.isRequired,
  // exact shape of individual event object varies depending on card type
  // eslint-disable-next-line react/forbid-prop-types
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  headingLevel: PropTypes.number,
  id: PropTypes.string.isRequired,
  isAnimated: PropTypes.bool,
  isFirstItem: PropTypes.bool,
  spacer: PropTypes.arrayOf(PropTypes.number),
};

export const DoubleEvent = ({
  id,
  spacer,
  events,
  date,
  isAnimated = false,
  containerDimension,
  isFirstItem = false,
  headingLevel,
}) => {
  const [pulse, setPulse] = useState(false);

  return (
    <>
      <StartDot pulse={pulse} />
      <ol
        className={classNames(styles.doubleEventContainer, {
          [styles.inContainer]:
            containerDimension && containerDimension !== 'full',
        })}
      >
        {events.map(event => (
          <li className={styles.doubleEventListItem} key={event.id}>
            {eventDecider(
              event,
              setPulse,
              date,
              id,
              isAnimated,
              containerDimension,
              isFirstItem,
              headingLevel,
            )}
          </li>
        ))}
      </ol>
      <Spacer id={id} spacer={spacer} />
    </>
  );
};

DoubleEvent.propTypes = {
  containerDimension: PropTypes.string,
  date: PropTypes.string.isRequired,
  // exact shape of individual event object varies
  // eslint-disable-next-line react/forbid-prop-types
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
  headingLevel: PropTypes.number,
  id: PropTypes.string.isRequired,
  isAnimated: PropTypes.bool,
  isFirstItem: PropTypes.bool,
  spacer: PropTypes.arrayOf(PropTypes.number),
};
